export const case01 = {
  name: "case1",
  to: "case1Page",
  title: "Cultivating Core User Empathy",
  tag: "Case Study 1",
  body: "Analyzing the factors that enhance user experience is a significant process before driving the car.",
  imageActivate01: true,
  imageActivate02: false,
  imageActivate03: false,
  imageActivate04: false,
  alt: "Image",
  imageLeft: true,
  paddingStart: false,
  paddingEnd: true,
  buttonLabel: "View Case Study 1",
};

export const case02 = {
  name: "case2",
  to: "case2Page",
  title: "Resolving Design Challenges",
  tag: "Case Study 2",
  body: "Challenges are ever-present, and addressing issues comprehensively is a problem-solving.",
  imageActivate01: false,
  imageActivate02: true,
  imageActivate03: false,
  imageActivate04: false,
  alt: "Image",
  imageLeft: false,
  paddingStart: false,
  paddingEnd: true,
  buttonLabel: "View Case Study 2",
};

export const case03 = {
  name: "case3",
  to: "case3Page",
  title: "Enhancing Website Profitability",
  tag: "Case Study 3",
  body: "Product appeal and profitability improve through continuous enhancements and ongoing analysis.",
  imageActivate01: false,
  imageActivate02: false,
  imageActivate03: true,
  imageActivate04: false,
  alt: "Image",
  imageLeft: true,
  paddingStart: false,
  paddingEnd: true,
  buttonLabel: "View Case Study 3",
};

export const case04 = {
  name: "case4",
  to: "case4Page",
  title: "Midnight Paloma",
  tag: "Case Study 4",
  body: "Midnight Paloma website was a long overdue revamp but has committed to completing it within a tight timeframe.",
  imageActivate01: false,
  imageActivate02: false,
  imageActivate03: false,
  imageActivate04: true,
  img: require("../../images/case_mp.png"),
  alt: "Image",
  imageLeft: false,
  paddingStart: false,
  paddingEnd: true,
  buttonLabel: "View Case Study 4",
};
